import axiosInstance from "../../axiosInstance.js";
import { baseUrl } from "../../endpoints.js";
import { configReq } from "../../../lib/functions.js";

/** Keeps the existing GET request and response contract. */
export function getRequest(api, extraParams, params, temp, token) {
  const query = new URLSearchParams(String(temp || "").replace(/^[?&]/, ""));
  if (extraParams) query.set(extraParams.name, extraParams.value);
  if (params) query.set("ids", params.replace(/^,/, ""));
  const suffix = query.toString();
  return axiosInstance(`${baseUrl}/${api}${suffix ? `?${suffix}` : ""}`, configReq(token));
}
